/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { readable_reward } from '../models/readable_reward';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WalletService {
    /**
     * Retrieve `Wallet` of a member.
     *
     * @param memberId Member identifier
     * @param retailerId Retailer identifier to filter rewards
     * @param from Filtered from this period
     * @param to Filtered to this period
     * @param daysAfterExpiry days after expiry
     * @returns any Successful operation, returning found wallet.
     * @throws ApiError
     */
    public static getMembersWallet(
        memberId: number,
        retailerId?: number,
        from?: string,
        to?: string,
        daysAfterExpiry?: number,
    ): CancelablePromise<{
        pending?: Array<readable_reward>;
        refused?: Array<readable_reward>;
        to_be_paid?: Array<readable_reward>;
        paid?: Array<readable_reward>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/members/{member_id}/wallet',
            path: {
                'member_id': memberId,
            },
            query: {
                'retailer_id': retailerId,
                'from': from,
                'to': to,
                'days_after_expiry': daysAfterExpiry,
            },
        });
    }
    /**
     * Retrieve `Wallet Summary` of a member.
     *
     * @param memberId Member identifier
     * @param from Filtered from this period
     * @param to Filtered to this period
     * @param asArray retailer map as an Array and not a Hash
     * @returns any Successful operation, returning found wallet summary.
     * @throws ApiError
     */
    public static getMembersWalletSummary(
        memberId: number,
        from?: string,
        to?: string,
        asArray?: boolean,
    ): CancelablePromise<{
        count?: number;
        amount?: number;
        retailers?: Array<{
            retailer_id?: number;
            count?: number;
            amount?: number;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/members/{member_id}/wallet_summary',
            path: {
                'member_id': memberId,
            },
            query: {
                'from': from,
                'to': to,
                'as_array': asArray,
            },
        });
    }
}
